<div class="main-container container-primary">
  <app-cookie-banner
    class="cookie-banner"
    [cookiePreference]="cookiesPreference$ | async"
    (acceptAll)="acceptCookies($event)"
    (customSettings)="customCookieSettings($event)"
  ></app-cookie-banner>

  <app-header
    class="header"
    [user]="userData"
    [navigationOpen]="navigationOpen"
    [profileSettingsOpen]="profileSettingsOpen"
    (navigationToggleClick)="onNavigationToggleClick($event)"
    (profileSettingsToggleClick)="onProfileSettingsToggleClick($event)"
  >
    @if (userData?.permissions.includes(UserPermission.OBJECTS)) {
      <ng-container
        search-field
        [ngTemplateOutlet]="prospectSearchTemplate"
      ></ng-container>
    }
  </app-header>

  <div class="sidenav-container">
    <app-navigation
      [navigationItems]="navigationItems"
      [narrow]="navigationStoredSettings?.narrow"
      [(open)]="navigationOpen"
      (narrowManualChange)="onNavigationNarrowManualChange($event)"
    ></app-navigation>

    <div
      class="sidenav-container__main-content"
      [class.warning-banner-aktive]="showWarningBanner"
    >
      @if (displayBannerAndFloatingButtons && showWarningBanner) {
        <app-performance-warning-banner
          [config]="warningBannerConfig"
          [confirmed]="confirmedPerformanceWarning$ | async"
          (confirm)="confirmPerformanceWarning()"
          [@fadeOnEnterLeave]
        ></app-performance-warning-banner>
      }
      @if (
        displayBannerAndFloatingButtons &&
        ((hasEmailVerified$ | async) !== true ||
          (emailVerifiedInCurrentSession$ | async)) &&
        (hideEmailBanner$ | async) !== true
      ) {
        <app-verify-email-banner
          [@fadeOnEnterLeave]
          [emailResent]="verificationEmailResent$ | async"
          [emailVerified]="
            (hasEmailVerified$ | async) ||
            (emailVerifiedInCurrentSession$ | async)
          "
          (resend)="resendVerificationEmail()"
        >
        </app-verify-email-banner>
      }

      <div class="content-container">
        <router-outlet></router-outlet>
      </div>
    </div>

    <app-navigation
      [ngClass]="showProfileSettingsNavigationInTemplate ? 'd-block' : 'd-none'"
      [navigationItems]="profileSettingsItems"
      [alignment]="'right'"
      [overlay]="true"
      [(open)]="profileSettingsOpen"
      (closedNavigationAnimationEnded)="
        showProfileSettingsNavigationInTemplate = false
      "
    >
      @if (userData && userData?.profile) {
        <app-navigation-user-profile
          navigationHeader
          [name]="userData?.profile?.firstname + ' ' + userData?.profile?.name"
          [email]="userData?.email"
          [portrait]="userData?.profile?.portrait"
        >
        </app-navigation-user-profile>
      }
      <app-footer
        navigationFooter
        [links]="footerLinks"
        [sideNavMode]="true"
      ></app-footer>
    </app-navigation>
  </div>
</div>

<section
  class="side-sheet__container"
  [class.cookies_header]="(cookiesPreference$ | async) === null"
  [@slide]="
    outlet?.activatedRouteData?.animation
      ? slideAnimationStateEnum.OPEN
      : slideAnimationStateEnum.CLOSED_RIGHT
  "
  [elevation]="2"
  appElevation
>
  <router-outlet #outlet="outlet" name="side"></router-outlet>
</section>

<ng-template #prospectSearchTemplate>
  <app-prospect-search></app-prospect-search>
</ng-template>
